import { groq } from 'next-sanity';

import { page } from './pageProps';

export const homepage = groq`*[_type == 'site'][0].homepage-> ${page}`;
